<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">ETA Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="eta_date_from"/> ~ <CustomDatePicker v-model="eta_date_to"/></span>

				<em class="lt_text">Item {{ headers.class }}</em>
				<span class="int_type_no_border mgr_5"> <ItemClassSelect v-model="itemClass" :showName="false" /> </span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable>
			<thead>
				<tr>
					<th width="8%">ETA</th>
					<th width="8%">Status</th>
					<th width="8%">Carton</th>
					<th width="8%">Delivery Type</th>
					<th>{{ headers.class }} Code</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(s, index) in schedule" v-bind:key="index">
					<td class="al_left">
						<a href="javascript:;" @click="selectOnBoardScheduleItemList(s.eta_date, s.carton, 'N')">{{ s.eta_date }}</a>
					</td>
					<td class="al_left">{{ s.status }}</td>
					<td class="al_left">{{ s.carton }}</td>
					<td class="al_left">{{ s.po_delivery_type_name }}</td>
					<td class="al_left">
						<template v-for="(c, index) in s.classList">
							<font :color="c.isNewStyle ? 'red' : c.isNewColor ? 'blue' : 'black'" v-bind:key="index">{{ c.code }}</font
							><template v-if="index != s.classList.length - 1">, </template>
						</template>
					</td>
					<!-- <td class="al_left">{{ purchase.eta_date }}</td>
					<td class="al_left">
						<a href="javascript:;" @click="gotoPartner(purchase.vendor_code)">{{ purchase.vendor_code }}</a>
					</td>
					<td v-if="user.company_id != 'newjigu'" class="al_left">
						<a href="javascript:;" @click="gotoPartner(purchase.vendor_code)">{{ purchase.vendor_name }}</a>
					</td>
					<td v-if="user.company_id != 'newjigu'" class="al_left">{{ purchase.payment_term_name }}</td>
					<td v-if="user.company_id != 'newjigu'" class="al_left">{{ purchase.payment_type_name }}</td>
					<td v-if="user.company_id != 'newjigu'" class="al_left">{{ purchase.trade_term_name }}</td>
					<td v-if="user.company_id == 'newjigu'" class="al_left truncate">{{ purchase.classes }}</td>
					<td class="al_left">{{ purchase.po_delivery_type_name }}</td>
					<td class="al_right">{{ purchase.total_quantity | commaSeparated }}</td>
					<td class="al_right">{{ purchase.total_amount | toCurrency }}</td>
					<td class="al_left truncate">{{ purchase.description }}</td>
					<td class="al_center">{{ purchase.closed_yn == 'Y' ? 'Closed' : 'Active' }}</td>
					<td class="al_center">{{ purchase.po_hold_type_code }}</td>					 -->
				</tr>
				<tr>
					<td colspan="5" style="background:dimgray;color:white;">Received {{ this_month_month }} {{ this_month_year }}</td>
				</tr>
				<tr v-for="(s, index) in thisMonthReceived" v-bind:key="10000 + index">
					<td class="al_left" style="background:lightgray;color:black;">
						<a href="javascript:;" @click="selectOnBoardScheduleItemList(s.eta_date, s.carton, 'Y')">{{ s.eta_date }}</a>
					</td>
					<td class="al_left" style="background:lightgray;color:black;">{{ s.status }}</td>
					<td class="al_left" style="background:lightgray;color:black;">{{ s.carton }}</td>
					<td class="al_left" style="background:lightgray;color:black;">{{ s.po_delivery_type_name }}</td>
					<td class="al_left" style="background:lightgray;color:black;">
						<template v-for="(c, index) in s.classList">
							<font :color="c.isNewStyle ? 'red' : c.isNewColor ? 'blue' : 'black'" v-bind:key="index">{{ c.code }}</font
							><template v-if="index != s.classList.length - 1">, </template>
						</template>
					</td>
				</tr>
				<tr>
					<td colspan="5" style="background:dimgray;color:white;">Received {{ prev_month_month }} {{ prev_month_year }}</td>
				</tr>
				<tr v-for="(s, index) in prevMonthReceived" v-bind:key="20000 + index">
					<td class="al_left" style="background:lightgray;color:black;">
						<a href="javascript:;" @click="selectOnBoardScheduleItemList(s.eta_date, s.carton, 'Y')">{{ s.eta_date }}</a>
					</td>
					<td class="al_left" style="background:lightgray;color:black;">{{ s.status }}</td>
					<td class="al_left" style="background:lightgray;color:black;">{{ s.carton }}</td>
					<td class="al_left" style="background:lightgray;color:black;">{{ s.po_delivery_type_name }}</td>
					<td class="al_left" style="background:lightgray;color:black;">
						<template v-for="(c, index) in s.classList">
							<font :color="c.isNewStyle ? 'red' : c.isNewColor ? 'blue' : 'black'" v-bind:key="index">{{ c.code }}</font
							><template v-if="index != s.classList.length - 1">, </template>
						</template>
					</td>
				</tr>
			</tbody>
		</table>

		<!-- #3312 JC 메인 표(예정·이번달·지난달 입고) Excel. Modal 안 Excel 은 품목 목록용이라 그대로 둔다. -->
		<div v-if="user.company_id == 'jc'" class="bottom_bt_box">
			<ul>
				<li><a href="javascript:void(0);" @click="excelMain()">Excel</a></li>
			</ul>
		</div>

		<Modal @close="closeModal" v-if="showModal" :draggable="false">
			<template slot="title">{{ eta_date }} / {{ carton }}</template>
			<template slot="body">
				<div :style="'width:' + popupWidth + 'px; height:' + popupHeight + 'px;'" v-on:keyup.esc="close()">
					<table class="list_tbl" border="0">
						<tr>
							<td style="vertical-align:top;" class="td_fixed" v-for="(dg, index) in dataGroups" v-bind:key="index">
								<!-- <template v-for="dg in dataGroups[j - 1]"> -->
								<!-- {{ JSON.stringify(dg) }} -->
								<table class="list_tbl" border="1" v-bind:key="index">
									<thead>
										<tr>
											<th style="background:yellow;width:100px;">{{ headers.class }}</th>
											<th style="background:yellow">Color</th>
											<th style="background:yellow;width:60px;">Qty</th>
											<th v-if="user.company_id == 'jc'" style="background:yellow;width:40px;">U/M</th>
										</tr>
									</thead>
									<tbody>
										<template v-for="(ig, index2) in dg.igs">
											<tr v-bind:key="1000 + index2">
												<td :rowspan="ig.items.length" class="al_left truncate" style="vertical-align:top;" :title="ig.class_code">{{ ig.class_code }}</td>
												<td class="al_left truncate" :title="ig.items[0].color_code">{{ ig.items[0].color_code }}</td>
												<td class="al_right">{{ ig.items[0].quantity | commaSeparated }}</td>
												<td v-if="user.company_id == 'jc'" class="al_center">{{ ig.items[0].purchase_unit_code }}</td>
											</tr>
											<tr v-for="(j, index3) in ig.items.length - 1" v-bind:key="index2 * 100 + index3">
												<td class="al_left truncate" :title="ig.items[j].color_code">{{ ig.items[j].color_code }}</td>
												<td class="al_right">{{ ig.items[j].quantity | commaSeparated }}</td>
												<td v-if="user.company_id == 'jc'" class="al_center">{{ ig.items[j].purchase_unit_code }}</td>
											</tr>
										</template>
										<tr v-if="index == dataGroups.length - 1">
											<td colspan="2">Grand Total</td>
											<td class="al_right">{{ grand_total | commaSeparated }}</td>
											<td v-if="user.company_id == 'jc'"></td>
										</tr>
										<!-- <tr v-for="(ig, index) in dg.igs" v-bind:key="1000 + index">
											<td>{{ ig.class_code }}</td>
											<td>T1</td>
											<td>T2</td>
										</tr> -->
									</tbody>
								</table>
								<!-- <template v-for="ig in dg.igs">
									{{ JSON.stringify(ig) }}
									*** {{ ig.class_code }} ***
									<template v-for="ci in ig.items">
										{{ ci.color_code }} | {{ ci.quantity }}
										{{ JSON.stringify(ci) }}
									</template>
								</template> -->
							</td>
						</tr>
					</table>

					<!-- <div v-for="(dg, index) in dataGroups" v-bind:key="index"> -->
					<!-- {{ index }} <br /> -->
					<!-- {{ index }} : {{ JSON.stringify(dg) }} -->
					<!-- <template v-for="ig in dg.igs"> -->
					<!-- {{ JSON.stringify(ig) }} || -->
					<!-- *** {{ ig.class_code }} *** -->
					<!-- <template v-for="ci in ig.items"> -->
					<!-- {{ ci.color_code }} | {{ ci.quantity }} -->
					<!-- {{ JSON.stringify(c) }} -->
					<!-- </template> -->
					<!-- </template> -->
					<!-- </div> -->
				</div>
				<div class="bottom_bt_box">
					<ul>
						<li><a href="javascript:void(0);" @click="excelExportItemList()">Excel</a></li>
					</ul>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
import { daysAgo, today, isDate, toDate, dateDiff } from '@/utils/date';
//import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import Modal from '@/components/common/Modal';
//import CodeSelect from '@/components/common/CodeSelect';
//import PartnerSelect from '@/components/common/PartnerSelect';
import ItemClassSelect from '@/components/common/ItemClassSelect';
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectOnBoardSchedule, apiSelectOnBoardScheduleItemList } from '@/api/purchase/purchase.js';
import XLSX from 'xlsx-js-style';
import { excelComplicated, exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';
import _ from 'lodash';

export default {
	props: ['headers'],
	data: function() {
		return {
			popupWidth: window.innerWidth - 100,
			popupHeight: window.innerHeight - 150,
			row_count_criteria: 30,

			uri: null,
			backUri: '/',
			// paging_yn: 'Y',
			// page_size: 25,
			// page_no: 1,
			//list_count: 0,

			sort_key: null,
			sort_direction: 'ASC',

			eta_date_from: today(),
			eta_date_to: daysAgo(-45),
			// vendor_code: null,
			// closed_yn: 'A',
			// keyword: null,
			itemClass: null,

			prev_month_year: null,
			prev_month_month: null,
			this_month_year: null,
			this_month_month: null,

			schedule: [],

			thisMonthReceived: [],
			prevMonthReceived: [],

			dataGroups: [],
			//dataRowCount: 0,
			//dataColCount: 2,

			excelItems: [],

			modalName: '',
			showModal: false,

			eta_date: null,
			carton: null,

			grand_total: 0,

			selected_po_no: null,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CustomDatePicker,
		Modal,
		// Paging,
		// PartnerSelect,
		ItemClassSelect,
	},
	methods: {
		// async excel() {
		// 	const { data } = await apiSelectPurchase({
		// 		po_no: this.selected_po_no,
		// 	});
		// 	this.excelItems = data.purchaseItemList;
		// 	//console.log(this.excelItems);
		// 	this.$nextTick(() => {
		// 		var elt = document.getElementById('exportTable');
		// 		var wb = XLSX.utils.table_to_book(elt, { raw: false });
		// 		return XLSX.writeFile(wb, 'Purchase_ItemList_' + data.purchase.po_dn + '.xlsx', { cellDates: true });
		// 	});
		// },
		// selectPurchase(purchase) {
		// 	this.$router.push({ name: 'purchaseDetail', params: { mode: 'detail' }, query: { backUri: this.uri, po_no: purchase.po_no } });
		// },
		// gotoPage(pageNo) {
		// 	this.page_no = pageNo;
		// 	this.selectPurchases(pageNo);
		// },
		// setPartner(partner) {
		// 	this.vendor_code = partner.code;
		// 	this.search();
		// },
		// selectPartner() {
		// 	this.modalName = 'PartnerSelect';
		// 	this.showModal = true;
		// },
		excelExportItemList() {
			if (!(this.dataGroups && this.dataGroups.length > 0)) {
				this.$toast.error('No data to Export.');
				return;
			}

			/* 
				data: 이차원 배열
				이차원 배열의 각 요소: { t: type, v: value, rs: rowspan, cs: colspan, s: {..}, height: '{hpx: ..}', width: '{wch: ..}' }
			*/
			const isJc = this.user.company_id == 'jc';
			const colsPerGroup = isJc ? 4 : 3;
			const title = [{ t: 's', v: this.eta_date + '/' + this.carton, cs: this.dataGroups.length * colsPerGroup, s: { font: { bold: true } } }];
			const headers = [];
			const data = [];
			const footers = [];
			this.dataGroups.forEach((dg, i) => {
				// header
				headers.push({ t: 's', v: this.headers.class, s: { fill: { fgColor: { rgb: 'FFFF00' } } } });
				headers.push({ t: 's', v: 'Color', s: { fill: { fgColor: { rgb: 'FFFF00' } } } });
				headers.push({ t: 's', v: 'Qty', s: { fill: { fgColor: { rgb: 'FFFF00' } } } });
				if (isJc) headers.push({ t: 's', v: 'U/M', s: { fill: { fgColor: { rgb: 'FFFF00' } } } });

				// data
				let row_number = 0;
				let col_number = colsPerGroup * i;
				if (dg.igs && Array.isArray(dg.igs)) {
					dg.igs.forEach(ig => {
						if (ig.items && Array.isArray(ig.items)) {
							ig.items.forEach((item, idx) => {
								if (!(data.length > row_number)) {
									data.push([]);

									// data row 추가시, 데이터가 표시될 셀의 위치를 맞추기 위해 이전 열의 셀을 빈칸으로 표시
									for (let j = 0; j < col_number; j++) {
										data[row_number].push({ t: 's', v: '' });
									}
								}

								if (idx === 0) data[row_number].push({ t: 's', v: ig.class_code, rs: ig.items.length });
								data[row_number].push({ t: 's', v: item.color_code });
								data[row_number].push({ t: 'n', v: item.quantity });
								if (isJc) data[row_number].push({ t: 's', v: item.purchase_unit_code || '' });

								row_number++;
							});
						}
					});
				}

				// data.length보다 행의 길이가 짧은 경우, 빈칸으로 data.length의 길이 만큼 값을 넣어 줌.
				if (data.length > row_number) {
					for (let j = 0; j < data.length - row_number; j++) {
						data[row_number + j].push({ t: 's', v: '' });
						data[row_number + j].push({ t: 's', v: '' });
						data[row_number + j].push({ t: 's', v: '' });
						if (isJc) data[row_number + j].push({ t: 's', v: '' });
					}
				}

				// footer
				if (i + 1 === this.dataGroups.length) {
					footers.push({ t: 's', v: 'Grand Total', s: { fill: { fgColor: { rgb: 'FFFF00' } } }, cs: 2 });
					footers.push({ t: 'n', v: this.grand_total });
					if (isJc) footers.push({ t: 's', v: '' });
				}
			});

			data.push(footers);
			data.unshift(headers);
			data.unshift(title);

			XLSX.writeFile(
				{
					SheetNames: ['Sheet1'],
					Sheets: {
						Sheet1: excelComplicated(data, { font: { sz: 13 }, alignment: { vertical: 'center' } }, 17),
					},
				},
				'on_board_schedule.xlsx',
			);
		},
		closeModal() {
			this.showModal = false;
		},
		// #3312 메인 표 Excel 행: 예정 → 'Received 이번달' 구분 행 → 이번달 입고 → 'Received 지난달' 구분 행 → 지난달 입고. Class Code 는 화면 순서(classList 정렬)대로 ', ' 로 잇는다.
		mainExcelRows() {
			const with_class_codes = list => (list || []).map(s => ({ ...s, class_codes: (s.classList || []).map(c => c.code).join(', ') }));
			return [].concat(
				with_class_codes(this.schedule),
				[{ eta_date: 'Received ' + this.this_month_month + ' ' + this.this_month_year }],
				with_class_codes(this.thisMonthReceived),
				[{ eta_date: 'Received ' + this.prev_month_month + ' ' + this.prev_month_year }],
				with_class_codes(this.prevMonthReceived),
			);
		},
		excelMain() {
			if (!((this.schedule && this.schedule.length) || (this.thisMonthReceived && this.thisMonthReceived.length) || (this.prevMonthReceived && this.prevMonthReceived.length))) {
				this.$toast.error('No data to Export.');
				return;
			}
			const headers = [
				{ key: 'eta_date', name: 'ETA', width: 14, dataType: defaultDataType.string },
				{ key: 'status', name: 'Status', width: 18, dataType: defaultDataType.string },
				{ key: 'carton', name: 'Carton', width: 10, dataType: defaultDataType.number },
				{ key: 'po_delivery_type_name', name: 'Delivery Type', width: 15, dataType: defaultDataType.string },
				{ key: 'class_codes', name: this.headers.class + ' Code', width: 60, dataType: defaultDataType.string },
			];
			exportDataExcel(this.mainExcelRows(), headers, 'OnBoardReceivedSchedule');
		},
		reset() {
			this.eta_date_from = today();
			this.eta_date_to = daysAgo(-45);
			// this.closed_yn = 'A';
			// this.vendor_code = null;
			// this.keyword = null;
			this.itemClass = null;
			//this.selectInvoices();
			// this.dept_code = null;
		},
		// sortMark: function(sort_key) {
		// 	if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
		// 	else return null;
		// },
		// sort(sort_key) {
		// 	if (this.sort_key == sort_key) {
		// 		this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
		// 	} else {
		// 		this.sort_key = sort_key;
		// 		this.sort_direction = 'ASC';
		// 	}
		// 	this.selectPurchases();
		// 	//console.log(sort_key);
		// },
		async search() {
			await this.selectOnBoardSchedule();
		},
		async selectOnBoardSchedule() {
			//console.log(isDate(this.eta_date_from), isDate(this.eta_date_to));
			if (!this.eta_date_from || !this.eta_date_to || !isDate(this.eta_date_from) || !isDate(this.eta_date_to)) {
				this.$toast.error('Invalid search date');
				return;
			}

			var eta_date_from = toDate(this.eta_date_from);
			var eta_date_to = toDate(this.eta_date_to);
			//console.log(eta_date_from, eta_date_to, 'hmmm:', dateDiff(eta_date_from, eta_date_to));
			if (dateDiff(eta_date_from, eta_date_to) > 60) {
				this.$toast.error('Maximum search period is 60 days');
				return;
			}

			var param = {
				// 	sort_key: this.sort_key,
				// 	sort_direction: this.sort_direction,
				eta_date_from: this.eta_date_from,
				eta_date_to: this.eta_date_to,
				class_code: this.itemClass,
				// 	vendor_code: this.vendor_code,
				this_month_year: this.this_month_year,
				this_month_month: this.this_month_month,
				prev_month_year: this.prev_month_year,
				prev_month_month: this.prev_month_month,
			};

			const { data } = await apiSelectOnBoardSchedule(param);
			//console.log(data);

			// this.purchases = data.purchaseList;
			//var vm = this;

			this.schedule = data.onBoardSchedule;
			this.schedule.forEach(s => {
				s.classList = [];
				//var classList = ([] = s.classes.split(','));
				//s.classList = s.classes.split(',');
				var classStringList = s.classes.split(',');
				classStringList.forEach(c => {
					var ci = { isNewStyle: false, isNewColor: false, code: null };

					var class_code = c.trim();
					if (class_code.startsWith('|NS|')) {
						ci.isNewStyle = true;
						ci.code = class_code.substring(4).trim();
					} else if (class_code.startsWith('|NC|')) {
						ci.isNewColor = true;
						ci.code = class_code.substring(4).trim();
					} else if (class_code.startsWith('|N|')) {
						ci.isNewStyle = true;
						ci.code = class_code.substring(3).trim();
					} else {
						ci.code = class_code;
					}

					//if (ci.code == vm.itemClass) ci.highlight = true;
					s.classList.push(ci);
				});
				//console.log(s.classList);
				s.classList = _.sortBy(s.classList, 'code');
			});

			this.thisMonthReceived = data.thisMonthReceivedList;
			this.thisMonthReceived.forEach(s => {
				s.classList = [];
				//var classList = ([] = s.classes.split(','));
				//s.classList = s.classes.split(',');
				var classStringList = s.classes.split(',');
				classStringList.forEach(c => {
					var ci = { isNewStyle: false, isNewColor: false, code: null };
					var class_code = c.trim();
					if (class_code.startsWith('|NS|')) {
						ci.isNewStyle = true;
						ci.code = class_code.substring(4).trim();
					} else if (class_code.startsWith('|NC|')) {
						ci.isNewColor = true;
						ci.code = class_code.substring(4).trim();
					} else if (class_code.startsWith('|N|')) {
						ci.isNewStyle = true;
						ci.code = class_code.substring(3).trim();
					} else {
						ci.code = class_code;
					}

					//if (ci.code == vm.itemClass) ci.highlight = true;
					s.classList.push(ci);
				});

				s.classList = _.sortBy(s.classList, 'code');
			});
			//console.log(this.thisMonthReceived);
			this.prevMonthReceived = data.prevMonthReceivedList;
			this.prevMonthReceived.forEach(s => {
				s.classList = [];
				//var classList = ([] = s.classes.split(','));
				//s.classList = s.classes.split(',');
				var classStringList = s.classes.split(',');
				classStringList.forEach(c => {
					var ci = { isNewStyle: false, isNewColor: false, code: null };
					//console.log(c);
					var class_code = c.trim();
					if (class_code.startsWith('|NS|')) {
						ci.isNewStyle = true;
						ci.code = class_code.substring(4).trim();
					} else if (class_code.startsWith('|NC|')) {
						ci.isNewColor = true;
						ci.code = class_code.substring(4).trim();
					} else if (class_code.startsWith('|N|')) {
						ci.isNewStyle = true;
						ci.code = class_code.substring(3).trim();
					} else {
						ci.code = class_code;
					}

					//if (ci.code == vm.itemClass) ci.highlight = true;
					s.classList.push(ci);
				});

				s.classList = _.sortBy(s.classList, 'code');
			});
			//console.log(this.prevMonthReceived);

			//this.list_count = this.schedule.length;

			var uri = '/purchase/on_board_schedule?dummy=1';
			// if (this.keyword) uri += '&keyword=' + this.keyword;
			// if (this.closed_yn) uri += '&closed_yn=' + this.closed_yn;
			if (this.eta_date_from) uri += '&eta_date_from=' + this.eta_date_from;
			if (this.eta_date_to) uri += '&eta_date_to=' + this.eta_date_to;
			// if (this.vendor_code) uri += '&vendor_code=' + this.vendor_code;
			if (this.itemClass) uri += '&itemClass=' + this.itemClass;
			////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		async selectOnBoardScheduleItemList(eta_date, carton, received_yn) {
			var param = {
				eta_date: eta_date,
				carton: carton,
				received_yn: received_yn,
			};

			const { data } = await apiSelectOnBoardScheduleItemList(param);

			this.items = data.onBoardScheduleItemList;
			//console.log(data.onBoardScheduleItemList);
			//var row_count_criteria = 30;
			//var row_count = 0;

			// const groupByCategory = data.onBoardScheduleItemList.groupByToMap(i => {
			// 	return i.class_code;
			// });

			// const groupByCategory = this.items.groupBy(i => {
			// 	return i.class_code;
			// });
			//const grouped = this.groupBy(this.items, item => item.class_code);
			//const grouped = this.groupBy(this.items, item => item.class_code);

			//console.log(grouped);
			//for (var i = 0; i < grouped.size; i++) console.log(grouped[i]);

			this.grand_total = 0;
			var prev_class_code = null;
			var itemGroups = [];
			var itemGroup = { class_code: null, items: [] };
			this.items.forEach(i => {
				if (i.class_code != prev_class_code) {
					prev_class_code = i.class_code;
					itemGroup = { class_code: i.class_code, items: [{ color_code: i.color_code, quantity: i.quantity, purchase_unit_code: i.purchase_unit_code }] };
					itemGroups.push(itemGroup);
				} else {
					itemGroup.items.push({ color_code: i.color_code, quantity: i.quantity, purchase_unit_code: i.purchase_unit_code });
				}
				this.grand_total += i.quantity;
			});

			//console.log(this.itemGroups);

			//var row_count_criteria = 35;

			var row_count = 0;
			var dataGroups = [];
			var dataGroup = { igs: [] };
			//var dataGroup = [];
			itemGroups.forEach(ig => {
				//console.log(row_count, ig.items.length);
				if (row_count == 0 || row_count + ig.items.length > this.row_count_criteria) {
					row_count = 0;
					//row_count = ig.items.length;
					// dataGroup = [];
					// dataGroup = [{ group: ig }];
					dataGroup = { igs: [] };
					dataGroups.push(dataGroup);
					//data
				} else {
					//row_count += ig.items.length;
					//dataGroup.groups.push({ group: ig });
				}
				row_count += ig.items.length;

				dataGroup.igs.push(ig);
			});

			this.dataGroups = dataGroups;

			//this.dataRowCount = parseInt(1 + (this.dataGroups.length - 1) / this.dataColCount);
			//console.log(this.dataGroups);

			this.eta_date = eta_date;
			this.carton = carton;
			this.showModal = true;
		},
		// gotoPartner(code) {
		// 	//console.log(code);
		// 	this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
		// },
		// async index() {
		// 	//const { data } = await apiIndex();
		// 	//this.salesGroups = data.salesGroupList;
		// 	//this.states = data.stateList;
		// },
		async init() {
			var td = toDate(today());
			//console.log(td.getFullYear(), td.getMonth() + 1);
			this.this_month_year = td.getFullYear();
			this.this_month_month = td.getMonth() + 1;

			if (this.this_month_month == 1) {
				this.prev_month_year = this.this_month_year - 1;
				this.prev_month_month = 12;
			} else {
				this.prev_month_year = this.this_month_year;
				this.prev_month_month = this.this_month_month - 1;
			}
			//console.log(this.prev_month_year, this.prev_month_month, this.this_month_year, this.this_month_month);
			// 	prev_month_year : null,
			// prev_month_month : null,
			// this_month_year : null,
			// this_month_month: null,
			//await this.index();
			// if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			// if (this.$route.query.closed_yn) this.closed_yn = this.$route.query.closed_yn;
			if (this.$route.query.eta_date_from) this.eta_date_from = this.$route.query.eta_date_from;
			if (this.$route.query.eta_date_to) this.eta_date_to = this.$route.query.eta_date_to;
			// if (this.$route.query.vendor_code) this.vendor_code = this.$route.query.vendor_code;
			if (this.$route.query.itemClass) this.itemClass = this.$route.query.itemClass;

			await this.selectOnBoardSchedule();
		},
	},
	created() {
		//this.$store.sideIndex = 2;
		this.$store.commit('setSideIndex', 2);
		//this.$store.selectedMenu = 'nav_li_5';
		this.$store.commit('setSelectedMenu', 'nav_li_onBoardSchedule');
		this.$store.commit('setSubTitle', 'Purchase -> On Board / Received Schedule');

		this.init();
	},
	mounted() {
		inputSelectOnClick();

		var vm = this;

		window.addEventListener('keyup', function(ev) {
			//self.myMethod(ev); // declared in your component methods
			if (vm.showModal && ev.code == 'Escape') vm.showModal = false;
		});
	},
};
</script>

<style>
.td_fixed {
	width: 250px;
	overflow: hidden;
	display: inline-block;
	white-space: nowrap;
}
</style>
